
import { supabase } from '@/integrations/supabase/client';
import { LeadFormData } from '@/types/leadForm';

export interface SupabaseLead {
  id?: string;
  firstname: string;
  email: string;
  phone: string;
  website: string;
  como_voce_ouviu_falar_sobre_a_conversion?: string;
  a_empresa_em_que_trabalho_e: string;
  seu_cargo: string;
  numero_de_funcionarios_na_empresa_em_que_trabalho: string;
  area_de_atuacao: string;
  created_at?: string;
  updated_at?: string;
}

class SupabaseLeadService {
  async saveLead(data: LeadFormData): Promise<boolean> {
    try {
      console.log('Salvando lead no Supabase:', data.email);
      
      const leadData: SupabaseLead = {
        firstname: data.firstname,
        email: data.email,
        phone: data.phone,
        website: data.website,
        como_voce_ouviu_falar_sobre_a_conversion: data.como_voce_ouviu_falar_sobre_a_conversion_ || null,
        a_empresa_em_que_trabalho_e: data.a_empresa_em_que_trabalho_e___,
        seu_cargo: data.seu_cargo,
        numero_de_funcionarios_na_empresa_em_que_trabalho: data.numero_de_funcionarios_na_empresa_em_que_trabalho,
        area_de_atuacao: data.area_de_atuacao,
      };

      // Tenta inserir primeiro
      const { data: insertResult, error: insertError } = await supabase
        .from('leads')
        .insert([leadData])
        .select();

      if (insertError) {
        // Se der erro de duplicata (email já existe), tenta fazer update
        if (insertError.code === '23505') {
          console.log('Email já existe, fazendo update:', data.email);
          
          const { data: updateResult, error: updateError } = await supabase
            .from('leads')
            .update(leadData)
            .eq('email', data.email)
            .select();

          if (updateError) {
            console.error('Erro ao fazer update do lead no Supabase:', updateError);
            return false;
          }

          console.log('Lead atualizado no Supabase com sucesso:', updateResult);
          return true;
        } else {
          console.error('Erro ao salvar lead no Supabase:', insertError);
          return false;
        }
      }

      console.log('Lead salvo no Supabase com sucesso:', insertResult);
      return true;
    } catch (error) {
      console.error('Erro ao processar lead no Supabase:', error);
      return false;
    }
  }

  async checkLeadExists(email: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .from('leads')
        .select('id')
        .eq('email', email)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Erro ao verificar se lead existe:', error);
        return false;
      }

      return !!data;
    } catch (error) {
      console.error('Erro ao verificar lead:', error);
      return false;
    }
  }

  async getLeadByEmail(email: string): Promise<SupabaseLead | null> {
    try {
      const { data, error } = await supabase
        .from('leads')
        .select('*')
        .eq('email', email)
        .single();

      if (error) {
        if (error.code === 'PGRST116') {
          return null; // Lead não encontrado
        }
        console.error('Erro ao buscar lead:', error);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Erro ao buscar lead:', error);
      return null;
    }
  }
}

export const supabaseLeadService = new SupabaseLeadService();
